import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import {
  listarClavesSatAdmin,
  type ListarClavesSatParams,
} from "../services/claves-sat-admin-service";

/**
 * Key local del listado ADMIN (paginado) · distinta de `qk.clavesSat`, que
 * es el catálogo completo del picker del wizard. Las mutations invalidan
 * ambas para que las dos vistas refresquen.
 */
export const clavesSatAdminKey = ["admin-claves-sat"] as const;

/**
 * Listado PAGINADO (server-side) para /admin/catalogos-sat · búsqueda +
 * página en el queryKey · `keepPreviousData` evita parpadeo al teclear.
 */
export const clavesSatAdminQueryOptions = (params: ListarClavesSatParams = {}) =>
  queryOptions({
    queryKey: [...clavesSatAdminKey, params] as const,
    queryFn: () => listarClavesSatAdmin(params),
    placeholderData: keepPreviousData,
  });

export const useClavesSatAdmin = (params: ListarClavesSatParams = {}) =>
  useQuery(clavesSatAdminQueryOptions(params));
